import { FC } from 'react';
import { Company } from '../../../../types/companies';
import styles from './styles.module.css';
import classNames from 'classnames';
import TableHead from './TableHead';
import TableRow from './TableRow';
import { CompanyFormDataProviderProps } from '../EditSideBar';

/** 編集・削除ボタンのためのカラムを表示するのに必要なポリシー (いずれがあれば表示) */
export const etcColumnRequiredPolicies = [25, 26] as const;

type Props = {
  companies: Company[];
  openEdit: (props: CompanyFormDataProviderProps | null) => void;
  sidebarClose: () => void;
};
const CompaniesTable: FC<Props> = ({ companies, openEdit, sidebarClose }) => {
  return (
    <table className={classNames(styles.table, 'rounded-corners')}>
      <TableHead />
      <tbody>
        {companies.map((c) => (
          <TableRow
            key={c.companyId}
            company={c}
            openEdit={openEdit}
            sidebarClose={sidebarClose}
          />
        ))}
      </tbody>
    </table>
  );
};

export default CompaniesTable;
